import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { holdItemShape, bibShape, childrenShape, paginationShape } from '@bibliocommons/bc-prop-types';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import { Placeholder } from '@bibliocommons/base-table';
import Pagination from '@bibliocommons/pagination';

import ItemList from '../../../shared/ItemList';
import InactiveHoldItem from '../InactiveHoldItem';

import './InactiveHoldsList.scss';

export default class InactiveHoldsList extends BcReactComponent {
  renderPagination(props = {}) {
    const { fetching, pagination, handleUpdatePage } = this.props;
    return pagination && (!pagination.isEmpty()) && (
      <Pagination
        {...props}
        isFetching={fetching}
        updatePage={handleUpdatePage}
        page={pagination.get('page')}
        limit={pagination.get('limit')}
        count={pagination.get('count')}
        pages={pagination.get('pages')} />
    );
  }

  renderBibListItem(item) {
    const { renderItemDetails, bibs } = this.props;
    const additionalDetails = renderItemDetails && renderItemDetails(item);
    return (
      <InactiveHoldItem
        key={item.get('holdsId')}
        item={item}
        bib={bibs.get(item.get('metadataId'))}
        additionalDetails={additionalDetails} />
    );
  }

  renderBibList() {
    const { fetching, items } = this.props;
    const showPlaceholder = fetching && (!items || items.isEmpty());

    return (
      <ItemList>
        <div className="count-and-pagination-row">
          <p className="holds-count">
            <FormattedMessage id="label_number_of_items" values={{ count: items.size }} />
          </p>
          {this.renderPagination({ className: 'top-pagination', autoFocus: true })}
        </div>
        {showPlaceholder ? <div className="placeholder-wrapper"><Placeholder /></div> : items.map(item => this.renderBibListItem(item)) }
        {this.renderPagination()}
      </ItemList>
    );
  }

  render() {
    const { title, fetching } = this.props;
    return (
      <div className="cp-inactive-holds-list">
        <ProgressBar active={fetching} />
        <h2>{title}</h2>
        <div className="list-wrapper">
          {this.renderBibList()}
        </div>
      </div>
    );
  }
}

InactiveHoldsList.propTypes = {
  title: childrenShape,
  items: ImmutablePropTypes.listOf(holdItemShape),
  bibs: ImmutablePropTypes.mapOf(bibShape),
  renderItemDetails: PropTypes.func,
  pagination: paginationShape,
  fetching: PropTypes.bool,
  handleUpdatePage: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/InactiveHoldsList/InactiveHoldsList.jsx